export const _emlMimeTypes = [
  "message/rfc822",
  'message/rfc822; version="1.0"',
];
